import { FormStateContext } from "@/components/bli-medlem/form-state-context";
import { HorizontalContainer } from "@/components/layout/horizontal-container";
import { HorizontalSpacer } from "@/components/layout/horizontal-spacer";
import { VerticalContainer } from "@/components/layout/vertical-container";
import { DynamicZone } from "@/components/ui/dynamic-zone";
import { RegisterButton } from "@/components/ui/register-button";
import {
  type CustomerTypeFragment,
  GetCustomerTypesDocument,
  type GetCustomerTypesQuery,
} from "@/generated/client.generated";
import { UsePage } from "@/hooks/use-page";
import { paths } from "@/utils/paths-utils";
import { useSuspenseQuery } from "@apollo/client";
import { usePathname, useSearchParams } from "next/navigation";
import { sort } from "rambda";
import { useContext } from "react";
import { sendStepEvent } from "./analytics";
import { ChangeRecurrenceTypeLink } from "./change-recurrence-type-link";
import { UserJourney } from "./types";

export function CustomerTypeForm() {
  const page = UsePage("/bli-medlem");
  const pathName = usePathname();
  const searchParams = useSearchParams();

  const { formData, currentStepIndex, next, step } = useContext(FormStateContext);
  const customerTypeList: ReadonlyArray<CustomerTypeFragment> =
    useSuspenseQuery<GetCustomerTypesQuery>(GetCustomerTypesDocument).data?.CustomerTypes ?? [];

  const orderedCustomerTypeList = sort(
    (a: CustomerTypeFragment, b: CustomerTypeFragment) => {
      return a.index >= b.index ? 1 : -1;
    },
    [...customerTypeList],
  );

  return (
    <>
      {step?.showDynamicZone && (
        <VerticalContainer horizontalPlacement="center" width="full">
          <HorizontalSpacer size="medium" />

          <DynamicZone blocks={page?.blocks ?? []} />
        </VerticalContainer>
      )}

      <HorizontalContainer horizontalPlacement="center">
        {orderedCustomerTypeList.map((ct) => (
          <RegisterButton
            key={ct.id}
            description={ct.description ?? undefined}
            ingress={ct.ingress ?? undefined}
            length={orderedCustomerTypeList.length}
            notification={ct.notification ?? undefined}
            onClick={() => {
              //analytics
              sendStepEvent(ct.title, currentStepIndex + 1, step?.shortTitle, formData.userJourney);

              if (`${pathName}?${searchParams.toString()}` === paths.bliMedlemPrefilled(formData.userJourney, ct.id)) {
                next();
              }
            }}
            url={paths.bliMedlemPrefilled(UserJourney.Recurring, ct.id)}
            selected={ct.id === formData.customerType?.id}
            title={ct.title}
          />
        ))}
        <RegisterButton
          ingress="Bedriftsmedlemskap på 3T"
          length={1}
          title="Bedrift"
          url={paths.bliMedlemPrefilled(UserJourney.Organization, "1")}
        />
      </HorizontalContainer>

      <HorizontalSpacer size="large" />

      {formData.userJourney && (
        <HorizontalContainer horizontalPlacement="center">
          <ChangeRecurrenceTypeLink userJourney={formData.userJourney} />
        </HorizontalContainer>
      )}
    </>
  );
}
